import { createContext, useContext } from 'react';

import { defaultConfig } from '../constants/defaultConfig';

export type ConfigContextState = typeof defaultConfig;

export const ConfigContext = createContext<ConfigContextState>(defaultConfig);

export const useConfigContext = () => useContext(ConfigContext);
